export default __webpack_public_path__ + "static/agatap-8063682f37158b98faac8978bc9c50b8.jpg";